import YouthDashboard from "./youth-dashboard";
import React from "react";

export const YouthDashboardRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "youth-dashboard",
      element: <YouthDashboard />,
    },
  ],
};
